module.exports = {
  disableWebNotifications: true,
};
